import * as React from "react";
import styled from "styled-components";

export const PageHeaderSpreader = styled.div`
    flex-grow: 1;
`;
